import { Tabs } from "antd";

import styled from "styled-components";

export const ProjectIntakeTabs = styled(Tabs)`
  .ant-tabs-nav {
    padding: 8px 0 0;
    margin-bottom: 0;
    background: #fff;
  }

  .ant-tabs-nav-wrap {
    justify-content: center;
    border: none;
    min-width: 0px;
  }

  .ant-tabs-tab {
    min-width: 120px;
    justify-content: center;
  }
`;

export const CommentsWrapper = styled.div`
  padding: 24px;
  background: #fff;
`;
